import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AchievementDetail from "../pages/achievement/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/achievement/:id",
    element: <AchievementDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;